module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/BEZHYs/images/cover.jpg?1684979335731",
      "alt": "This image is the cover for the book When Memory Fails, Falling and When Memory Fails"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("When Memory Fails, Falling and When Memory Fails\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("Sequel to Falling")])])]), _c('p', [_vm._v("It's been two years since Hank Ballam and Scott Alan fell in love, moved in together, and started building their life. Hank has kept his promise to his boss—and Scott’s brother—Brian, proving he can be both his adrenaline-seeking self and a good worker. While Hank enjoys being Brian's right-hand man, nothing gives him more pleasure than going home to Scott every night. But then a major announcement gets Hank thinking about the family he left behind, and he wonders if there is any hope of including them in his new life with Scott.")]), _vm._v(" "), _c('p', [_vm._v("Seeing Hank's turmoil, Scott quietly reaches out to his lover's family—without telling Hank. Scott is overjoyed when Hank’s sister seems receptive, but the reunion doesn't go as planned, leaving Scott to wonder if he’s unleashed a series of events that might take Hank from him forever.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      D.W. Marchwell\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0